import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Dropdown from "components/forms/inputs/dropdown";
import { OptionInterface } from "components/forms/inputs/dropdown.styles";
import TextInput from "components/forms/inputs/text";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import Modal from "components/layout/modal";
import { parse } from "lib/locale";
import { SchemaColumn } from "models/generic";
import { ListEntity } from "models/list-entity";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { useLocale } from "stores/hooks/locale";
import { useTranslate } from "stores/hooks/translation";
import * as yup from "yup";

interface ListSchemaAddColumnModalProps {
  entities: ListEntity[];
  onUpdate: (column: SchemaColumn) => Promise<void>;
  onClose: () => Promise<void>;
}

const ListSchemaAddColumnModal: FunctionComponent<
  ListSchemaAddColumnModalProps
> = ({ entities, onClose, onUpdate }) => {
  const t = useTranslate();
  const locale = useLocale();

  const formSchema = yup
    .object({ type: yup.string().validateRequired(), width: yup.string() })
    .required();

  const options: OptionInterface[] = [];
  options.push({ value: "name", text: t(`column_type_name`) });
  options.push({
    value: "liabilities",
    text: t(`column_type_liabilities`),
  });
  options.push({ value: "modified", text: t(`column_type_modified`) });
  options.push({ value: "status", text: t(`column_type_status`) });

  for (let e = 0; e < entities.length; e += 1) {
    const entity = entities[e];
    const { listEntityFields = [] } = entity;
    for (let f = 0; f < listEntityFields.length; f += 1) {
      const field = listEntityFields[f];
      const value = `field:${field.uuid}`;
      options.push({
        value,
        text: [parse(entity.name, locale), parse(field.name, locale)].join(
          ", ",
        ),
      });
    }
  }

  const methods = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: { type: options[0].value, width: "" },
  });

  const handleSubmit = async (values: any) => {
    const { type, width } = values;
    const schema: SchemaColumn = {
      type: type.includes("field:") ? "field" : type,
      fieldUuid: type.includes("field:") ? type.split(":")[1] : undefined,
      width: width ? parseInt(width) : undefined,
    };
    onUpdate(schema);
    onClose();
  };

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton },
  ];

  return (
    <Modal title="Lisää sarake">
      <Form methods={methods} onSubmit={handleSubmit}>
        <Grid>
          <Row>
            <Col>
              <Dropdown
                name="type"
                label="Lisättävä sarake"
                options={options}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInput
                name="width"
                label="Koko"
                placeholder="Leveys pikseleissä. Jätä tarvittaessa tyhjäksi."
              />
            </Col>
          </Row>
        </Grid>
        <FormButtons buttons={buttons} />
      </Form>
    </Modal>
  );
};

export default ListSchemaAddColumnModal;
